import CrownIcon from "../../icons/crownIcon";
import TwoUsersIcon from "../../icons/twoUsersIcon";
import UserRemoveIcon from "../../icons/userRemoveIcon";
import { PiCurrencyCircleDollar } from "react-icons/pi";

const Cards = ({ t }) => {
  const cards = [
    {
      title: t("activeMembersCount"),
      number: "320",
      icon: <TwoUsersIcon />,
    },
    {
      title: t("expiredMemberships"),
      number: "11",
      icon: <UserRemoveIcon fill={"#902929"} />,
    },
    {
      title: t("vipRequests"),
      number: "12",
      icon: <CrownIcon />,
    },
    {
      title: t("revenue"),
      number: "14,200 JD",
      icon: <PiCurrencyCircleDollar size={24} fill="#D1A855" />,
    },
  ];
  return (
    <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {cards.map((card, i) => {
        return (
          <div
            key={i}
            className="border-[#D1A8551A] border flex items-start justify-between gap-4 rounded-2xl p-6 lg:p-4 shadow-md mainLinear"
          >
            <div>
              <h3 className="mb-3 text-sm lg:max-w-[101px] font-medium text-mainGray">
                {card.title}
              </h3>
              <p className="my-2 text-2xl font-bold">{card.number}</p>
            </div>
            <span className="grid rounded-full bg-mainBg place-content-center size-11">
              {card.icon}
            </span>
          </div>
        );
      })}
    </section>
  );
};

export default Cards;
